import styled, { css } from 'styled-components'
import {
  brandSecondary,
  brandSecondaryDarker,
  defaultBorderRadius,
  mainHeaderColor,
  media,
  transition,
  white,
} from 'utils/style-utils'

export const Box = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
`

export const FilterElement = styled.div<{ active: boolean }>`
  height: calc(100% - 0.25rem);
  margin-top: 0.25rem;
  padding: 0 0.75rem 0.25rem;
  display: flex;
  align-items: center;
  border-radius: ${defaultBorderRadius};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  user-select: none;

  color: ${mainHeaderColor};
  word-break: keep-all;
  white-space: nowrap;

  cursor: pointer;

  ${transition('all', 0.5)};

  svg {
    fill: ${mainHeaderColor};
    width: 1.5rem;
    height: 1.5rem;

    ${transition('all', 0.5)};
  }

  :hover {
    color: ${white};
    text-shadow:
      0 0 4px ${white},
      0 0 16px ${white},
      0 0 32px ${white},
      0 0 64px ${white};

    svg {
      fill: ${white};
      filter: drop-shadow(0 0 4px ${white}) drop-shadow(0 0 16px ${white});
    }
  }

  ${({ active }) =>
    active
      ? css`
          color: ${brandSecondary};
          pointer-events: none;
          background: ${brandSecondaryDarker};

          svg {
            fill: ${brandSecondary};
          }
        `
      : ''}
`

export const ProvidersBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  overflow-x: auto;
  max-width: 100%;
`

export const ProviderElement = styled(FilterElement)`
  svg {
    display: none;
  }

  ${media.sm`
    span {
      display: none;
    }
    svg {
      display: unset;
    }
  `}
`
